import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AdminHeader from "../components/AdminHeader";

const AdminLayout: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const checkSession = async () => {
      try {
        const res = await fetch(`${API_URL}/session`, { credentials: "include" });
        const data = await res.json();
        if (!data.user) navigate("/login");
      } catch (err) {
        console.error(err);
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };
    checkSession();
  }, [API_URL, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen text-gray-500">
        Loading...
      </div>
    );
  }

  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-gray-100">
      {/* Mobile Top Header */}
      <div className="md:hidden">
        <AdminHeader apiUrl={API_URL || ""} variant="header" />
      </div>

      {/* Sidebar for md+ screens */}
      <aside className="hidden md:flex w-64 bg-white shadow-md h-screen sticky top-0 flex-col">
        <AdminHeader apiUrl={API_URL || ""} variant="sidebar" />
      </aside>

      {/* Main content */}
      <main className="flex-1 p-6 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
